var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-goods-rank d-flex align-items-center"},[_c('span',{staticClass:"p-goods-rank__low_rank_text font-italic font-weight-bold"},[_vm._v("\n    No."+_vm._s(_vm.rank)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }